import {useLocation} from 'react-router-dom';
import type {BreadcrumbItem} from '@/components/breadcrumbs/Breadcrumbs';
import useCreatorProfileQuery from '@/hooks/queries/use-creator-profile-query';
import useBrandId from '@/hooks/use-brand-id';
import {LISTS_BREADCRUMB_ROUTES} from '../breadcrumbRouteDefinitions';
import {matchBreadcrumbRoutes} from '../breadcrumbRouteTypes';

function useListsBreadcrumbItems(): BreadcrumbItem[] | null {
  const {pathname} = useLocation();
  const brandId = useBrandId();

  const matched = matchBreadcrumbRoutes(LISTS_BREADCRUMB_ROUTES, pathname);

  const {creatorId} = matched?.params ?? {};

  const {profile: creatorProfile} = useCreatorProfileQuery({
    profileId: creatorId ?? null,
    brandId,
    enabled: !!creatorId,
    include: [],
  });

  if (!matched) return null;

  const data = {
    creatorName: creatorProfile?.displayName,
  };

  return matched.route
    .getItems(matched.params, data)
    .filter((item) => item.label);
}

export default useListsBreadcrumbItems;
